(()=>{
  const root=document.querySelector('[data-it-calc-root]');
  const source=document.querySelector('[data-it-history]');
  const holder=document.querySelector('[data-history-chart]');
  if(!root||!source||!holder)return;

  const mode=(root.dataset.calcMode||'combined').toLowerCase();
  const money=value=>'£'+Number(value).toLocaleString('en-GB',{minimumFractionDigits:2,maximumFractionDigits:2});
  const niceDate=date=>new Date(date+'T12:00:00Z').toLocaleDateString('en-GB',{day:'numeric',month:'short',year:'numeric'});

  function rows(){
    let parsed=[];
    try{
      parsed=JSON.parse(source.textContent||'[]');
      if(typeof parsed==='string')parsed=JSON.parse(parsed||'[]');
    }catch(_){parsed=[];}
    if(!Array.isArray(parsed))return[];
    return parsed.map(row=>({
      date:String(row?.date||row?.timestamp||'').slice(0,10),
      gold:Number(row?.gold),
      silver:Number(row?.silver)
    })).filter(row=>/^\d{4}-\d{2}-\d{2}$/.test(row.date)).sort((a,b)=>a.date.localeCompare(b.date));
  }

  function activeMetal(){
    const selected=document.querySelector('[data-history-metal].is-active');
    if(selected?.dataset.historyMetal)return selected.dataset.historyMetal;
    return mode==='silver'?'silver':'gold';
  }

  function activeDays(){
    const selected=document.querySelector('[data-history-range].is-active');
    return Number(selected?.dataset.historyRange)||30;
  }

  function view(){
    const all=rows();
    if(!all.length)return[];
    const metal=activeMetal();
    const latest=Date.parse(all[all.length-1].date+'T12:00:00Z');
    const cutoff=latest-(activeDays()-1)*86400000;
    return all.filter(row=>Date.parse(row.date+'T12:00:00Z')>=cutoff&&Number.isFinite(row[metal])&&row[metal]>0);
  }

  function draw(){
    const data=view();
    if(data.length!==2)return;
    const canvas=holder.querySelector('canvas');
    const state=holder.querySelector('[data-history-state]');
    if(!canvas)return;

    holder.closest('.it-authority__section')?.classList.remove('it-history-pending');
    canvas.hidden=false;
    if(state)state.hidden=true;

    const metal=activeMetal();
    const dpr=Math.max(1,Math.min(2,window.devicePixelRatio||1));
    const cssW=Math.max(320,holder.clientWidth-32||900);
    const cssH=300;
    canvas.width=Math.round(cssW*dpr);
    canvas.height=Math.round(cssH*dpr);
    canvas.style.width=cssW+'px';
    canvas.style.height=cssH+'px';

    const c=canvas.getContext('2d');
    if(!c)return;
    c.setTransform(dpr,0,0,dpr,0,0);
    c.clearRect(0,0,cssW,cssH);

    const values=data.map(row=>row[metal]);
    let min=Math.min(...values),max=Math.max(...values);
    const base=Math.max(Math.abs(max),1);
    let span=max-min;
    if(span<base*.002){span=base*.02;min-=span/2;max+=span/2;}
    else{const padding=span*.18;min-=padding;max+=padding;}
    span=Math.max(.0001,max-min);

    const pad={l:64,r:24,t:25,b:44};
    c.font='12px Arial, sans-serif';
    c.lineWidth=1;
    for(let i=0;i<=4;i++){
      const y=pad.t+(cssH-pad.t-pad.b)*i/4;
      c.strokeStyle='#dfe4e8';
      c.beginPath();c.moveTo(pad.l,y);c.lineTo(cssW-pad.r,y);c.stroke();
      const val=max-span*i/4;
      c.fillStyle='#596875';
      c.fillText(money(val),6,y+4);
    }

    const lineColor=metal==='gold'?'#a77a24':'#596773';
    const fillColor=metal==='gold'?'rgba(183,139,63,.12)':'rgba(95,108,118,.12)';
    const points=data.map((row,index)=>({
      x:pad.l+(cssW-pad.l-pad.r)*index,
      y:pad.t+(max-row[metal])/span*(cssH-pad.t-pad.b)
    }));

    c.beginPath();
    c.moveTo(points[0].x,points[0].y);
    c.lineTo(points[1].x,points[1].y);
    c.lineTo(points[1].x,cssH-pad.b);
    c.lineTo(points[0].x,cssH-pad.b);
    c.closePath();
    c.fillStyle=fillColor;c.fill();

    c.beginPath();c.moveTo(points[0].x,points[0].y);c.lineTo(points[1].x,points[1].y);
    c.strokeStyle=lineColor;c.lineWidth=3;c.stroke();
    points.forEach(point=>{c.beginPath();c.arc(point.x,point.y,4,0,Math.PI*2);c.fillStyle='#fff';c.fill();c.strokeStyle=lineColor;c.lineWidth=2;c.stroke();});

    c.fillStyle='#596875';c.font='11px Arial, sans-serif';
    c.fillText(niceDate(data[0].date),pad.l,cssH-14);
    const endLabel=niceDate(data[1].date),endWidth=c.measureText(endLabel).width;
    c.fillText(endLabel,cssW-pad.r-endWidth,cssH-14);
    canvas.setAttribute('aria-label',(metal==='gold'?'Gold':'Silver')+' reference price history in pounds per gram from '+niceDate(data[0].date)+' to '+niceDate(data[1].date));
  }

  const schedule=()=>window.requestAnimationFrame(()=>window.requestAnimationFrame(draw));
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',schedule,{once:true});
  else schedule();
  document.addEventListener('click',event=>{
    if(event.target.closest('[data-history-metal],[data-history-range]'))window.setTimeout(draw,0);
  });
  window.addEventListener('resize',schedule,{passive:true});
})();
